module.exports = __webpack_public_path__ + "media/roomBgm.b37a97b0.mp3";